import styled from "styled-components";

export const PhoneFieldWrapper = styled.div<{
  $language: "ar" | "en";
  $isError: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;

  > label {
    font-weight: 400;
    text-align: start;
    color: #435363;
    font-size: 15px;
    margin: 0 0 4px;
    display: flex;
    flex-direction: row;
    gap: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    .req {
      color: #ef4444;
    }
  }

  .PhoneInput {
    padding: 6px 16px;
    height: 48px;
    background: #fff;
    border: 1px solid ${(p) => (p.$isError ? "#EF4444" : "#e5e7eb")};
    border-radius: 12px;
    gap: 8px;
    /* Keep the flag/selector on the inline-start in both directions. */
    flex-direction: ${(p) => (p.$language === "en" ? "row" : "row-reverse")};

    .PhoneInputCountry {
      margin: 0;
      gap: 8px;
    }
    .PhoneInputInput {
      border: none;
      border-inline-start: 1px solid ${(p) => (p.$isError ? "#EF4444" : "#e2e8f0")};
      padding-inline: 10px;
      height: 100%;
      /* honour document direction instead of forcing right-align */
      text-align: start;
      outline: none;
      background: transparent;
      color: ${(p) => (p.$isError ? "#EF4444" : "#261B6A")};
    }
  }

  .ErrorMessageStyle {
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    color: #ef4444;
    min-height: 20px;
    margin-top: 2px;
    p {
      margin: 0;
    }
  }
`;
